<template>
    <div class="relative rounded-md">
        <img src="./img/crash_result.jpg" class="rounded-md" />
        <span
            class="absolute text font-black text-4xl left-1/2 top-[79%] -translate-x-1/2 -translate-y-1/2"
            >{{ history.stopped }}x
        </span>
    </div>
</template>
<script lang="ts" setup>
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
});
</script>
<style scoped>
.text {
    text-shadow: #7c67ff 0 -0.703622px 18.9978px;
}
</style>
